import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#09090b] text-white font-['Manrope'] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center border border-zinc-800 bg-zinc-900/50 rounded-lg p-10" data-testid="checkout-cancel">
        <XCircle size={56} className="mx-auto text-zinc-500 mb-5" strokeWidth={1.5} />
        <h1 className="font-['Outfit'] font-black text-3xl tracking-tight mb-3">Paiement annulé</h1>
        <p className="text-zinc-400 mb-8">Aucun montant n'a été débité. Vous pouvez revenir aux offres à tout moment.</p>
        <button
          data-testid="back-to-pricing"
          onClick={() => navigate("/#tarifs")}
          className="inline-flex items-center gap-2 bg-white text-zinc-950 font-bold px-6 py-3 rounded-md hover:bg-zinc-200 transition-colors"
        >
          <ArrowLeft size={18} strokeWidth={2.5} /> Retour aux offres
        </button>
      </div>
    </div>
  );
}
